import React from 'react';
export const SECTION_ID = 'section-welcome';
import { staticImageAssets } from 'js/constants/Paths';

import CtaPageBlocks from 'js/components/cta/CTA.page-blocks';

const HeaderRegionHome = ({ title, description, ctas }) => {
  return (
    <section id={SECTION_ID} className={`header-region header-region--header-region ${SECTION_ID}`}>
      <div className="container">
        <div className={`header-region__upper-section`}>
          <div className={`header-region__hero-panel`}>
            <figure>
              <picture>
                <source
                  media="(max-width:768px)"
                  srcSet={`${staticImageAssets('images/static/welcome_panel_mobile.png')}`}
                />
                <img
                  src={staticImageAssets('images/static/welcome_panel_desktop.png')}
                  alt="Get updates for Stan & Gran"
                  title="Get updates for Stan & Gran"
                  width="650"
                  height="702"
                />
              </picture>
            </figure>
          </div>

          <div className={`header-region__description`}>
            <h1>{title}</h1>
            <h2>{description}</h2>
            <img
              className="header-region__description--milkshake"
              src={staticImageAssets('images/static/coming_soon_to_milkshake.png')}
              alt="Coming soon to Milkshake"
              title="Coming soon to Milkshake"
              width="300"
              height="137"
            />
          </div>
        </div>

        {ctas && ctas?.content && ctas?.content?.length > 0 && (
          <div className={`header-region__lower-section`}>
            <CtaPageBlocks ctas={ctas} />
          </div>
        )}
      </div>

      <figure className={`header-region__footprints`}>
        <picture>
          <source
            media="(max-width:768px)"
            srcSet={`${staticImageAssets('images/static/welcome_footprints_mobile.png')}`}
          />
          <img
            src={staticImageAssets('images/static/welcome_footprints_desktop.png')}
            alt="Bird footprints"
            title="Bird footprints"
          />
        </picture>
      </figure>
    </section>
  );
};

export default HeaderRegionHome;
